import React, { useState } from 'react';
import { Button, Text, View } from "../../../src/Components/Themed"
import type { LeagueProps } from '../../../src/types';
import { FlatList, Image, Modal, useWindowDimensions } from 'react-native';
import { useColors } from '../../../src/constants/useColors';
import { Icons } from '../../../src/Components';
import SearchBox from '../../../src/Components/SearchBox';

type LeagueSelectorProps = {
    leagues:LeagueProps[],
    mode:'desktop'|'mobile',
    visible:boolean,
    insets:{ top:number, bottom:number, left:number, right:number },
    active_league?:string,
    hide_other?:boolean,
    onClose:() => void,
    onLeagueSelect: (league:string) => void,
}

const LeagueSelector = ({ leagues, mode, visible, hide_other, insets, active_league, onClose, onLeagueSelect }:LeagueSelectorProps) => {
    const Colors = useColors();
    const { width, height } = useWindowDimensions();
    const embed_height = height * 0.9
    const embed_width = width * 0.9

    const [ league_search, setLeagueSearch ] = useState<{
        visible:boolean,
        value: string
    }>({
        visible: false,
        value: ''
    });

    let filtered_leagues = [ ...leagues ]
    if(league_search.visible){
        filtered_leagues = filtered_leagues.filter(l => `${l.league_name}`.toLowerCase().includes(league_search.value.toLowerCase()));
    }

    const renderLeagues = (data:{ item:LeagueProps, index:number }) => {
        return (
            <Button style={{ flexDirection:'row', alignItems:'center', padding:10, borderBottomWidth:1, borderColor:Colors.borders.light }}
            onPress={() => onLeagueSelect(data.item.league_name)}>
                <Image
                    source={{ uri: data.item.league_image }}
                    style={{ height:35, width:35 }}
                    resizeMode='contain'
                />
                <View transparent style={{ flex:1, marginLeft:10 }}>
                    <Text theme='description'>{data.item.league_name}</Text>
                </View>
            </Button>
        )
    }

    return (
        <Modal
            visible={visible}
            transparent
            style={{ flex:1 }}
            animationType={mode == 'desktop' ? 'fade' : 'slide'}
        >
            <View type='blur' style={mode=='desktop'?{ flex:1, justifyContent:'center', alignItems:'center' }:{ flex:1 }}>
                <View float style={mode=='desktop'?{ height:embed_height - insets.bottom - insets.top - 10, width:embed_width - insets.left - insets.right }:{ flex:1, marginTop:insets.top + 10, marginBottom: insets.bottom + 10, marginLeft:insets.left + 10, marginRight: insets.right + 10  }}>
                    <View type='header' style={{ flexDirection:'row', alignItems:'center', padding:10 }}>
                        <View transparent style={{flex:1}}>
                            <Text theme='h1'>Select League</Text>
                        </View>
                        <Button float style={{ padding:10 }} onPress={() => setLeagueSearch({ visible: !league_search.visible, value: '' })}>
                            {league_search.visible ?
                            <Icons.SearchIcon size={12} color={Colors.text.error}/>
                            :
                            <Icons.SearchIcon size={12} color={Colors.text.h1} />
                            }
                        </Button>
                        <Button float style={{ padding:10, marginLeft:10 }} onPress={() => onClose()}>
                            <Icons.CloseIcon size={12} color={Colors.text.error}/>                            
                        </Button>
                    </View>
                    {league_search.visible ?
                    <View>
                        <SearchBox 
                            onChange={(text) => setLeagueSearch({ ...league_search, value: text })}
                            hide_search_button
                        />
                    </View>
                    :<></>}
                    <View type='body' style={{ flex:1 }}>
                        {!hide_other ?
                        <Button style={{ flexDirection:'row', alignItems:'center', padding:10, borderBottomWidth:1, borderColor:Colors.borders.light }}
                        onPress={() => onLeagueSelect('Popular')}>
                            <Icons.FlameIcon size={35} color={Colors.text.error} />
                            <View transparent style={{ flex:1, marginLeft:10 }}>
                                <Text theme='description'>Popular</Text>
                            </View>
                        </Button>
                        :<></>}
                        <FlatList
                            data={filtered_leagues.filter(l => l.status == 'active').sort((a,b) => a.priority - b.priority)}
                            renderItem={renderLeagues}
                            key={'league_selector_list'}
                            keyExtractor={(item) => item.league_id.toString()}
                        />
                    </View>
                </View>
            </View>
        </Modal>
    )
}

export default LeagueSelector